export const provincies = [
  { code: 22, label: 'Drenthe', country: 'nl' },
  { code: 27, label: 'Noord-Holland', country: 'nl' },
  { code: 25, label: 'Gelderland', country: 'nl' },
  { code: 21, label: 'Friesland', country: 'nl' },
  { code: 28, label: 'Zuid-Holland', country: 'nl' },
  { code: 23, label: 'Overijssel', country: 'nl' },
  { code: 24, label: 'Flevoland', country: 'nl' },
  { code: 30, label: 'Noord-Brabant', country: 'nl' },
  { code: 26, label: 'Utrecht', country: 'nl' },
  { code: 20, label: 'Groningen', country: 'nl' },
  { code: 31, label: 'Limburg', country: 'nl' },
  { code: 29, label: 'Zeeland', country: 'nl' },
  { code: 100, label: 'ZL-ZH' , country: 'nl' }, // Zeeland + Zuid-Holland combined

  // Vlaanderen
  { code: 10000, label: 'Antwerpen', country: 'be' },
  { code: 70000, label: 'Limburg', country: 'be' },
  { code: 40000, label: 'Oost-Vlaanderen', country: 'be' },
  { code: 20001, label: 'Vlaams-Brabant', country: 'be' },
  { code: 30000, label: 'West-Vlaanderen', country: 'be' },
  { code: 50000, label: 'Henegouwen', country: 'be' },
  { code: 60000, label: 'Luik', country: 'be' },
  { code: 80000, label: 'Luxemburg', country: 'be' },
  { code: 90000, label: 'Namen', country: 'be' },
  { code: 20002, label: 'Waals-Brabant', country: 'be' },

  // United Kingdom
  { code: 1000, label: 'England', country: 'uk' },
  { code: 2000, label: 'Scotland', country: 'uk' },
  { code: 3000, label: 'Wales', country: 'uk' },
  { code: 4000, label: 'Northern Ireland', country: 'uk' },

  // Deutschland (Bundesländer) - codes are the official AGS Land prefixes (first
  // two digits of a Kreis AGS), so a Kreis' province is derivable from its code.
  { code: 1, label: 'Schleswig-Holstein', country: 'de' },
  { code: 2, label: 'Hamburg', country: 'de' },
  { code: 3, label: 'Niedersachsen', country: 'de' },
  { code: 4, label: 'Bremen', country: 'de' },
  { code: 5, label: 'Nordrhein-Westfalen', country: 'de' },
  { code: 6, label: 'Hessen', country: 'de' },
  { code: 7, label: 'Rheinland-Pfalz', country: 'de' },
  { code: 8, label: 'Baden-Württemberg', country: 'de' },
  { code: 9, label: 'Bayern', country: 'de' },
  { code: 10, label: 'Saarland', country: 'de' },
  { code: 11, label: 'Berlin', country: 'de' },
  { code: 12, label: 'Brandenburg', country: 'de' },
  { code: 13, label: 'Mecklenburg-Vorpommern', country: 'de' },
  { code: 14, label: 'Sachsen', country: 'de' },
  { code: 15, label: 'Sachsen-Anhalt', country: 'de' },
  { code: 16, label: 'Thüringen', country: 'de' },
]
